import React from 'react';
import { Alert, Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import * as styles from 'styles/index.scss';

const { weekRenderOnboardAlert, weekRenderOnboardCompleteButton } = styles;

export const OnboardingAlert = ({ productInPath, onLinkClick }) => (
  <Alert color="primary" className={weekRenderOnboardAlert}>
    <p>
      You are currently viewing the Getting Started Welcome page. This page introduces you to the structure of the
      weekly guides you will have access to as a member of WHOLE Life Club. It includes a short action of the week,
      recipes, a simple action checklist, and more resources, and a chance to engage with the Community. Every time you
      come back to the club you will see this page until you have completed the short checklist at the bottom.
    </p>

    <p>
      If you're done with this page,{' '}
      <Link to={`/products/${productInPath}/current-week`} className="alert-link" onClick={onLinkClick}>
        click here to go to the most recent Weekly Guide
      </Link>
    </p>
  </Alert>
);

export const OnboardingCompleteButton = ({ complete, onClick }) => (
  <div className={weekRenderOnboardCompleteButton}>
    <Button color="purple" disabled={!complete} onClick={onClick}>
      {complete ? 'Continue to your first week' : 'Continue on when complete...'}
    </Button>
  </div>
);
